export default "__VITE_ASSET__BiV8EDwG__"